// Configuración de la API
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || 'development';

// Función para construir URLs completas
export const buildApiUrl = (endpoint) => {
  // Si el endpoint ya es una URL completa, la devolvemos tal como está
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    return endpoint;
  }
  
  // Si el endpoint comienza con /, lo concatenamos con la base URL
  if (endpoint.startsWith('/')) {
    return `${API_BASE_URL}${endpoint}`;
  }
  
  // Si no, agregamos el / antes de concatenar
  return `${API_BASE_URL}/${endpoint}`;
};

// URLs de endpoints comunes
export const API_ENDPOINTS = {
  VEHICLE_CATEGORIES: '/api/vehicle-categories',
  AVAILABILITY: '/api/availability',
  BOOKING: '/api/booking',
  BOOKING_PARTIAL_CONFIG: '/api/booking/partial-deposit-config',
  BOOKING_TEMP: '/api/booking/temp',
  BOOKING_CONFIRM: '/api/booking/confirm',
  PAYMENT: '/api/payment',
  PAYMENT_CREATE_INTENT: '/api/payment/create-intent',
  PAYMENT_CONFIRM: '/api/payment/confirm',
  VEHICLE_MODELS: '/api/vehicle-models',
  ACCESSORIES: '/api/accessories'
};

// Configuración exportada
export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENVIRONMENT,
  ENDPOINTS: API_ENDPOINTS
};

export default API_CONFIG; 